export default __webpack_public_path__ + "static/media/flashcards.09c0f4d2.gif";